<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Controls</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (controlVoltageSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Control Voltage:</label>
            <select class="halfWidthInputField" #controlVoltageInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlVoltageSelection.Name)"
              (change)="selectionChanged(controlVoltageSelection, controlVoltageInput.value)"
              [value]="controlVoltageSelection.Value.toString()">
              @for (allowable of controlVoltageSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="controlVoltageSelection.Value && controlVoltageSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (serviceSwitchSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Service Switch:</label>
            <select class="halfWidthInputField" #serviceSwitchInput
              [class.invalidConfigurationSelection]="isInvalidSelection(serviceSwitchSelection.Name)"
              (change)="selectionChanged(serviceSwitchSelection, serviceSwitchInput.value)"
              [value]="serviceSwitchSelection.Value.toString()">
              @for (allowable of serviceSwitchSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="serviceSwitchSelection.Value && serviceSwitchSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (thermostatTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Thermostat Type:</label>
            <select class="halfWidthInputField" #thermostatInput
              [class.invalidConfigurationSelection]="isInvalidSelection(thermostatTypeSelection.Name)"
              (change)="selectionChanged(thermostatTypeSelection, thermostatInput.value)"
              [value]="thermostatTypeSelection.Value.toString()">
              @for (allowable of thermostatTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="thermostatTypeSelection.Value && thermostatTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (skyportServiceSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(skyportServiceSelection.Name)"
              for="skyportServiceInput"
            class="halfWidthInputLabel">IEC Skyport Setup Service<br/>(Wi-Fi Thermostat):</label>
            <input type="checkbox" class="checkboxInput" id="skyportServiceInput"
              #skyportServiceInput [checked]="'true' === skyportServiceSelection.Value"
              (change)="selectionChanged(skyportServiceSelection, skyportServiceInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (thermostatLocationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Thermostat Location:</label>
            <select class="halfWidthInputField" #thermostatLocationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(thermostatLocationSelection.Name)"
              (change)="selectionChanged(thermostatLocationSelection, thermostatLocationInput.value)"
              [value]="thermostatLocationSelection.Value.toString()">
              @for (allowable of thermostatLocationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="thermostatLocationSelection.Value && thermostatLocationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (condensateSwitchSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(condensateSwitchSelection.Name)"
            for="condensateSwitchInput" class="halfWidthInputLabel">Condensate Switch:</label>
            <input type="checkbox" class="checkboxInput" id="condensateSwitchInput"
              #condensateSwitchInput [checked]="'true' === condensateSwitchSelection.Value"
              (change)="selectionChanged(condensateSwitchSelection, condensateSwitchInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput"></span>
        @if (terminalStripSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(terminalStripSelection.Name)"
            for="terminalStripInput" class="halfWidthInputLabel">Terminal Strip:</label>
            <input type="checkbox" class="checkboxInput" id="terminalStripInput"
              #terminalStripInput [checked]="'true' === terminalStripSelection.Value"
              (change)="selectionChanged(terminalStripSelection, terminalStripInput.checked.toString())">
          </span>
        }
      </div>
    </div>
  }
</div>
